export default __webpack_public_path__ + "static/media/flower.11f54fb6.svg";